import floatLabels from '../globals/forms';
import {setVarsOnResize, setVars} from '../globals/height';
import preloadImages from '../globals/preload-images';
import resizeListener from '../globals/resize';
import scrollListener from '../globals/scroll';
import wrapElements from '../globals/wrap';
import isTouch from '../util/touch';
import {ariaToggle} from '../globals/aria-toggle';
import {loading} from '../globals/loading';
import {loadedImagesEventHook, removeLoadingClassFromLoadedImages} from '../globals/images';
import {PredictiveSearch} from '../globals/predictive-search';
import {Popout} from '../globals/popout';
import {QuantityCounter} from '../globals/quantity-handle';
import {initAnimations} from '../globals/animations';
import DeferredImage from '../globals/deferred-image';
import DeferredMedia from '../globals/deferred-media';

// Safari requestIdleCallback polyfill
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };
window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

if (window.theme.settings.enableAnimations) {
  initAnimations();
}

resizeListener();
scrollListener();
isTouch();
setVars();
loadedImagesEventHook();

window.addEventListener('DOMContentLoaded', () => {
  setVarsOnResize();
  ariaToggle(document);
  floatLabels(document);
  wrapElements(document);
  removeLoadingClassFromLoadedImages(document);
  loading();

  if (window.fastNetworkAndCPU) {
    preloadImages();
  }

  requestIdleCallback(() => {
    if (Shopify.visualPreviewMode) {
      document.documentElement.classList.add('preview-mode');
    }
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const container = e.target;
  floatLabels(container);
  wrapElements(container);
  ariaToggle(document);
  setVarsOnResize();
});

if (!customElements.get('popout-select')) {
  customElements.define('popout-select', Popout);
}

if (!customElements.get('quantity-counter')) {
  customElements.define('quantity-counter', QuantityCounter);
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}

if (!customElements.get('deferred-image')) {
  customElements.define('deferred-image', DeferredImage);
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}
